import { useNavigate } from "react-router-dom";
import styles from "./ArrowBack.module.css";
import { ArrowBackOutlined } from "@mui/icons-material";

interface Props {
  to?: string;
  title?: string;
}

const ArrowBack = ({ to, title }: Props) => {
  const router = useNavigate();

  const goBack = () => {
    router(to || "..");
  };

  return (
    <div onClick={goBack} className={styles.container}>
      <ArrowBackOutlined />
      <div className={styles.title}>{title}</div>
    </div>
  );
};

export default ArrowBack;
